import { type I18n } from "@client/types";
import apiV1 from "@common/lib/api";
import { type Unsubscribe } from "./types";

export default {
  unsubscribe: (i18n: I18n, args: Unsubscribe.Api.UnsubscribeRequest): Promise<void> =>
    apiV1.post(i18n, `/user/process/unsubscribeUser`, args)
};
